import {HttpClient} from "../../service/httpClient/HttpClient";

export class GameTeamService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getTeamList(gamePeriodId, page, size, title,status) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `game-periods/${gamePeriodId}/teams`,
                {
                    page,
                    size,
                    "title": title && title.length > 0 ? title : null,
                    "status": status && status !== "ALL" && status.length > 0 ? status : null
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewTeam(gamePeriodId, title) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `game-periods/${gamePeriodId}/teams`,
                {
                    title
                }
            ).then(resolve).catch(reject)
        })
    }

    getTeamInfo(gameTeamId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `game-teams/${gameTeamId}/information`
            ).then(resolve).catch(reject)
        })
    }

    updateTeamInfo(gameTeamId, title) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `game-teams/${gameTeamId}/information`,
                {},
                {
                    title
                }
            ).then(resolve).catch(reject)
        })

    }

    getAdmissionSettings(gameTeamId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `game-teams/${gameTeamId}/admission-settings`
            ).then(resolve).catch(reject)
        })
    }

    updateAdmissionSettings(gameTeamId, status) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `game-teams/${gameTeamId}/admission-setting`,
                {},
                {
                    status
                }
            ).then(resolve).catch(reject)
        })
    }

}